import React from "react";

import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  AddIcon,
  EditIcon,
  InfoOutlinedIcon,
  InvoiceIcon,
  LinkOffIcon,
  RemoveIcon,
} from "../../../components/common/iconography";
import { getFormTab } from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const OutboundCreateHelp = (props) => {
  const classes = useStyles();
  var tab = getFormTab(props);

  return (
    <>
      {(() => {
        switch (tab) {
          case "0":
            return (
              <>
                <Typography variant="overline">
                  <strong>Outbound Setup</strong>
                </Typography>
                <ul>
                  <li>
                    <Typography>
                      <strong>PO Number: </strong>
                      Purchase Order number provided by Customer.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Carrier Name: </strong>
                      Rail line / truck line name.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Carrier Type: </strong>
                      Select carrier type - determines "Pickup Number" or
                      "Railcar Number".
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Pickup Number: </strong> Required if Carrier Type
                      = "Truck".
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Railcar Number: </strong>
                      Required if shipping by Rail and Carrier Type = "Rail".
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Must Tarp: </strong>
                      Required if Carrier Type = "Truck". Indicate if load needs
                      to be covered with tarp.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Destination Name & Address: </strong>
                      Optional - can be left blank for "Blind Shipments". If
                      Destination entered, address is required.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Attachments: </strong>
                      Attach the original PO from customer.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="overline">
                      <strong>Custom Fields</strong>
                    </Typography>
                    <Typography>
                      User-defined in Account setup. These fields are
                      Account-specific, so they may differ from one inbound to
                      another.
                    </Typography>
                  </li>
                </ul>
              </>
            );
          case "1":
            return (
              <>
                <Typography variant="overline">
                  <strong>Pick List</strong>
                </Typography>
                <ul>
                  <li>
                    <Typography>
                      <strong>Product Name: </strong>
                      Product name as displayed in the Inventories. Items linked
                      to Product Catalog will have an{" "}
                      <InfoOutlinedIcon className={classes.icon} /> Info Bubble
                      in the right corner. Those not linked to a Product, will
                      display <LinkOffIcon className={classes.icon} /> broken
                      link icon.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Qty. On Hand: </strong>Stock quantity in storage.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Qty. Committed: </strong>
                      Stock quantity Reserved across all Outbound Shipments,
                      including this one - dynamically updated.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Qty. Available: </strong>
                      Stock quantity available of Outbound Shipment, inclusive
                      of Qty. Committed in this shipment.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Qty. Outbound: </strong>Stock quantity Reserved
                      for this shipment.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="overline">
                      <strong>Custom Fields</strong>
                    </Typography>
                    <Typography>
                      User-defined in Account setup or Product Catalog. These
                      fields are Account- and Product-specific, so they may
                      differ from one inbound to another.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <AddIcon className={classes.icon} />
                      <strong> ADD: </strong>
                      Add new Line Item to Pick List. Launches "Inventory
                      Search" dialog. Account must be selected on Shipment Setup
                      Tab to enable the Add button. Inventory Search dialog
                      allows you to search for All Inventories by hitting the
                      Search button, or narrowing down results by product name,
                      or lot number.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <RemoveIcon className={classes.icon} />
                      <strong> REMOVE: </strong>
                      Remove selected Pick List Line Item and adjust global
                      Inventory counts.
                    </Typography>
                  </li>
                  <li>
                    <Typography gutterBottom>
                      <strong>Total Quantity & Shipping Units: </strong>
                      Sum total of Qty. Outbound. Indicate units of measure for
                      counting Qty shipped.
                    </Typography>
                  </li>
                  <li>
                    <Typography gutterBottom>
                      <strong>Bill Quantity & Units: </strong>
                      Total Qty. Outbound and Units used for invoicing customer.
                      If Billing Units = Weight Units, the measured truck weight
                      will be used for invoicing.
                    </Typography>
                  </li>
                </ul>
              </>
            );
          default:
            return (
              <>
                <Typography variant="overline">
                  <strong>Notes</strong>
                </Typography>
                <Typography variant="subtitle1">
                  Use the Notes Tab to document key events and changes made to
                  the Shipment record.
                </Typography>
                <ul>
                  <li>
                    <Typography>
                      <AddIcon className={classes.icon} />
                      <strong> ADD: </strong>Add new Note Line Item.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <RemoveIcon className={classes.icon} />
                      <strong> REMOVE: </strong>
                      Remove selected Note Line Item - this info will be
                      permanently lost.
                    </Typography>
                  </li>
                </ul>
              </>
            );
        }
      })()}
    </>
  );
};

export const OutboundEditHelp = (props) => {
  const classes = useStyles();
  var tab = getFormTab(props);

  return (
    <>
      {(() => {
        switch (tab) {
          case "0":
            return (
              <>
                <Typography variant="overline">
                  <strong>Outbound Setup</strong>
                </Typography>
                <ul>
                  <li>
                    <Typography>
                      <strong>Carrier Name: </strong>
                      Rail line / truck line name.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Carrier Type: </strong>
                      Select carrier type - determines "Pickup Number" or
                      "Railcar Number".
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Pickup Number: </strong> Required if Carrier Type
                      = "Truck".
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Railcar Number: </strong>
                      Required if shipping by Rail and Carrier Type = "Rail".
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Must Tarp: </strong>
                      Required if Carrier Type = "Truck". Indicate if load needs
                      to be covered with tarp.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Destination Name & Address: </strong>
                      Optional - can be left blank for "Blind Shipments". If
                      Destination entered, address is required.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Attachemnts: </strong>
                      Attach the original PO from customer.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="overline">
                      <strong>Custom Fields</strong>
                    </Typography>
                    <Typography>
                      User-defined in Account setup. These fields are
                      Account-specific, so they may differ from one inbound to
                      another.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <InvoiceIcon className={classes.icon} />
                      <strong> INVOICE: </strong>Generate new Invoice for this
                      Outbound Shipment.
                    </Typography>
                  </li>
                </ul>
              </>
            );
          case "1":
            return (
              <>
                <Typography variant="overline">
                  <strong>Pick List</strong>
                </Typography>
                <ul>
                  <li>
                    <Typography>
                      <strong>Product Name: </strong>
                      Product name as displayed in the Inventories. Items linked
                      to Product Catalog will have an{" "}
                      <InfoOutlinedIcon className={classes.icon} /> Info Bubble
                      in the right corner. Those not linked to a Product, will
                      display <LinkOffIcon className={classes.icon} /> broken
                      link icon.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Qty. On Hand: </strong>Stock quantity in storage.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Qty. Committed: </strong>
                      Stock quantity Reserved across all Outbound Shipments,
                      including this one - dynamically updated.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Qty. Available: </strong>
                      Stock quantity available of Outbound Shipment, inclusive
                      of Qty. Committed in this shipment.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Qty. Outbound: </strong>Stock quantity Reserved
                      for this shipment.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="overline">
                      <strong>Custom Fields</strong>
                    </Typography>
                    <Typography>
                      User-defined in Account setup or Product Catalog. These
                      fields are Account- and Product-specific, so they may
                      differ from one inbound to another.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <AddIcon className={classes.icon} />
                      <strong> ADD: </strong>
                      Add new Line Item to Pick List. Launches "Inventory
                      Search" dialog. Account must be selected on Shipment Setup
                      Tab to enable the Add button. Inventory Search dialog
                      allows you to search for All Inventories by hitting the
                      Search button, or narrowing down results by product name,
                      or lot number.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <RemoveIcon className={classes.icon} />
                      <strong> REMOVE: </strong>
                      Remove selected Pick List Line Item and adjust global
                      Inventory counts.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <EditIcon className={classes.icon} />
                      <strong> EDIT: </strong>
                      Edit Qty. Outbound of selected Line Item. After saving or
                      cancelling changes, you will be brought back to this
                      screen.
                    </Typography>
                  </li>
                  <li>
                    <Typography gutterBottom>
                      <strong>Total Quantity & Shipping Units: </strong>
                      Sum total of Qty. Outbound. Indicate units of measure for
                      counting Qty shipped.
                    </Typography>
                  </li>
                  <li>
                    <Typography gutterBottom>
                      <strong>Bill Quantity & Units: </strong>
                      Total Qty. Outbound and Units used for invoicing customer.
                      If Billing Units = Weight Units, the measured truck weight
                      will be used for invoicing.
                    </Typography>
                  </li>
                </ul>
              </>
            );
          case "2":
            return (
              <>
                <Typography variant="overline">
                  <strong>Dispatch</strong>
                </Typography>
                <Typography variant="subtitle1">
                  Use the Dispatch Tab to capture key event timestamps when the
                  shipment is advanced from Pending > Placed > Released status.
                  Alternatively, you can advance a record directly from the
                  "Outboud Shipment" List view.
                </Typography>
                <ul>
                  <li>
                    <Typography>
                      <strong>Date Created: </strong>
                      Date customer advised of Outbound Shipment.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Time Placed: </strong>
                      Time of Arrival when the Carrier arrives and checks in
                      with the Yard.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Empty Weight & Units: </strong>
                      Empty truck weight at time of Arrival. Used for invoicing
                      if Units = Billing Units.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Load Start Time:</strong> Time when Crew started
                      loading outbound inventory.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Load End Time:</strong> Time when Crew finished
                      loading outbound inventory.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Time Released:</strong> Time shipment was approved
                      and Released.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Loaded Weight & Units: </strong>
                      Loaded truck weight at time of Departure. Used for
                      invoicing if Units = Billing Units.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <strong>Seal Number: </strong>
                      Seal tag number for shipments that require sealing.
                    </Typography>
                  </li>
                </ul>
              </>
            );
          case "3":
            return (
              <>
                <Typography variant="overline">
                  <strong>Notes</strong>
                </Typography>
                <Typography variant="subtitle1">
                  Use the Notes Tab to document key events and changes made to
                  the Shipment record.
                </Typography>
                <ul>
                  <li>
                    <Typography>
                      <AddIcon className={classes.icon} />
                      <strong> ADD: </strong>Add new Note Line Item.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      <RemoveIcon className={classes.icon} />
                      <strong> REMOVE: </strong>
                      Remove selected Note Line Item - this info will be
                      permanently lost.
                    </Typography>
                  </li>
                </ul>
              </>
            );
          default:
            return (
              <>
                <Typography variant="overline">
                  <strong>History</strong>
                </Typography>
                <Typography variant="subtitle1">
                  The History Tab provides an automated, chronological Audit
                  Trail of key events and record changes.
                </Typography>
              </>
            );
        }
      })()}
    </>
  );
};
